import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

const LoginCallback = () => {
  const { oktaAuth } = useOktaAuth();

  React.useEffect(() => {
    const handleCallback = async () => {
      try {
        await oktaAuth.handleLoginRedirect();
        console.log('Login callback handled successfully');
      } catch (error) {
        console.error('Login callback error:', error);
      }
    };

    handleCallback();
  }, [oktaAuth]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div>Processing login...</div>
      <div style={{ marginTop: '20px' }}>
        <div className="spinner" style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 2s linear infinite'
        }}></div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoginCallback;
